import { gql } from "@apollo/client"
import { TransitionInvoiceInput, TransitionInvoicePayload } from "@oysterhr/schema"

import { useMutation, InjectedOptions } from "@oysterhr/core"

export const MUTATION = gql`
  mutation TransitionInvoice(
    $invoiceId: ID!
    $event: InvoiceTransitionEvent!
    $disputeReason: String
  ) {
    transitionInvoice(
      input: { invoiceId: $invoiceId, event: $event, disputeReason: $disputeReason }
    ) {
      invoice {
        id
        state
      }
      errors
    }
  }
`

export const useTransitionInvoice = (
  options?: InjectedOptions<
    { transitionInvoice: TransitionInvoicePayload },
    TransitionInvoiceInput
  >,
) =>
  useMutation<{ transitionInvoice: TransitionInvoicePayload }, TransitionInvoiceInput>(
    MUTATION,
    options,
  )
